import { render, staticRenderFns } from "./Atividade.vue?vue&type=template&id=4d14838a"
import script from "./Atividade.vue?vue&type=script&lang=js"
export * from "./Atividade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports